import { render } from "./GameHeader.vue?vue&type=template&id=2613f7e6&scoped=true"
import script from "./GameHeader.vue?vue&type=script&lang=js"
export * from "./GameHeader.vue?vue&type=script&lang=js"

import "./GameHeader.vue?vue&type=style&index=0&id=2613f7e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2613f7e6"]])

export default __exports__